export class BaseModel {
  constructor() { }
  allowedFiles: string[];
}
